import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { login } from "../../store/reducers/authReducer";
import { CFV } from "../common/others/Functions";
import OpacityLoading from "../common/loader/OpacityLoading";
import bsLogo from "../../assets/common/comps/bsLogo.png";

const DEFAULT_UNAUTH_STORAGE_KEY = "defaultUnAuthRoute";

const MainUnAuthSBS = () => {
  const dispatch = useDispatch();
  const { todosLoading } = useSelector((state) => state.todosReducer);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    localStorage.setItem(DEFAULT_UNAUTH_STORAGE_KEY, "mainSBS");
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setIsLoading(true);
    const body = { ...data };
    dispatch(login(body)).then((res) => {
      setIsLoading(false);
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
      } else toast.error(res.payload?.error);
    });
  };

  return (
    <div style={styles.container}>
      {/* Background gradient overlay */}
      <div style={styles.gradientOverlay} />

      {/* Content */}
      <div style={styles.content}>
        {/* Logo Section */}
        <div style={styles.logoSection}>
          <img src={bsLogo} alt="Be Simple Events" style={styles.logo} />
        </div>

        {/* Login Card */}
        <div style={styles.loginCard}>
          <h3 style={styles.loginTitle}>התחברות למערכת</h3>

          <form onSubmit={handleSubmit(onSubmit)} style={styles.form}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>מספר נייד</label>
              <input
                style={styles.input}
                placeholder="050XXXXXXX"
                {...register("phone", {
                  required: true,
                  pattern: /^[0]{1}[5]{1}[0-9]{8}$/,
                })}
              />
              {CFV("phone", "פורמט מספר פלאפון לא חוקי", errors)}
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>סיסמא</label>
              <input
                style={styles.input}
                type="password"
                placeholder="הזן סיסמא"
                {...register("password", {
                  required: true,
                  minLength: 2,
                  maxLength: 20,
                })}
              />
              {CFV("password", "בין 2 ל 20 תווים", errors)}
            </div>

            <button type="submit" style={styles.submitButton}>
              כניסה למערכת
            </button>
          </form>
        </div>

        {/* Footer */}
        <p style={styles.footer}>© Be Simple Events 2021</p>
      </div>

      {(todosLoading || isLoading) && <OpacityLoading />}
    </div>
  );
};

const styles = {
  container: {
    width: "100%",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    background:
      "linear-gradient(180deg, #1a1a3e 0%, #2d2855 28%, #ffffff 50%, #ffffff 100%)",
  },
  gradientOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
      "radial-gradient(ellipse at top, rgba(69, 65, 120, 0.25) 0%, transparent 50%)",
    pointerEvents: "none",
  },
  content: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around",
    minHeight: "100vh",
    padding: "12px 16px 24px",
    width: "100%",
    maxWidth: "360px",
  },
  logoSection: {
    textAlign: "center",
  },
  logo: {
    width: "280px",
    height: "auto",
    marginBottom: "0",
    marginTop: "-15px",
    filter: "drop-shadow(0 2px 12px rgba(0,0,0,0.2))",
  },
  tagline: {
    color: "#ffffff",
    fontSize: "24px",
    fontWeight: "700",
    marginBottom: "10px",
    textShadow: "0 2px 10px rgba(0,0,0,0.3)",
    fontFamily: "'Heebo', sans-serif",
  },
  subtitle: {
    color: "rgba(255,255,255,0.8)",
    fontSize: "16px",
    fontWeight: "400",
    fontFamily: "'Heebo', sans-serif",
  },
  loginCard: {
    background: "rgba(255, 255, 255, 0.96)",
    borderRadius: "16px",
    padding: "16px 18px",
    width: "100%",
    boxShadow: "0 4px 24px rgba(0, 0, 0, 0.12)",
  },
  loginTitle: {
    color: "#2d2855",
    fontSize: "18px",
    fontWeight: "600",
    textAlign: "center",
    marginBottom: "12px",
    fontFamily: "'Heebo', sans-serif",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  label: {
    color: "#2d2855",
    fontSize: "13px",
    fontWeight: "500",
    fontFamily: "'Heebo', sans-serif",
  },
  input: {
    background: "#f8f8f9",
    border: "1px solid #e8e8ec",
    borderRadius: "10px",
    padding: "10px 14px",
    fontSize: "15px",
    color: "#2d2855",
    outline: "none",
    transition: "all 0.2s ease",
    fontFamily: "'Heebo', sans-serif",
    direction: "rtl",
  },
  submitButton: {
    background:
      "linear-gradient(135deg, rgb(48, 43, 99), rgba(68, 59, 149, 0.55))",
    border: "none",
    borderRadius: "10px",
    padding: "10px",
    fontSize: "15px",
    fontWeight: "600",
    color: "#ffffff",
    cursor: "pointer",
    transition: "all 0.2s ease",
    marginTop: "4px",
    fontFamily: "'Heebo', sans-serif",
    boxShadow: "0 2px 12px rgba(26, 26, 62, 0.35)",
  },
  footer: {
    color: "#1a1a1a",
    fontSize: "11px",
    fontFamily: "'Heebo', sans-serif",
  },
};

export default MainUnAuthSBS;
